module.exports = __webpack_public_path__ + "static/media/flag_yellow_low.8e789a66.jpg";